"use strict";
exports.__esModule = true;
exports.restoreSchema = exports.removeSchema = exports.updateSchema = exports.createSchema = void 0;
var types_1 = require("../types");
var validators_1 = require("../validation/validators");
exports.createSchema = function (collectionId) {
    var patches = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        patches[_i - 1] = arguments[_i];
    }
    validators_1.validateCollectionId(collectionId);
    return {
        collectionId: collectionId,
        patches: patches,
        type: types_1.SchemaOperationType.CREATE
    };
};
exports.updateSchema = function (collectionId) {
    var patches = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        patches[_i - 1] = arguments[_i];
    }
    validators_1.validateCollectionId(collectionId);
    return {
        collectionId: collectionId,
        patches: patches,
        type: types_1.SchemaOperationType.UPDATE
    };
};
exports.removeSchema = function (collectionId) {
    validators_1.validateCollectionId(collectionId);
    return {
        collectionId: collectionId,
        type: types_1.SchemaOperationType.REMOVE
    };
};
exports.restoreSchema = function (collectionId) {
    var patches = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        patches[_i - 1] = arguments[_i];
    }
    validators_1.validateCollectionId(collectionId);
    return {
        collectionId: collectionId,
        patches: patches,
        type: types_1.SchemaOperationType.RESTORE
    };
};
//# sourceMappingURL=operations.js.map